export default function Values() {
  const values = [
    {
      title: 'Innovation',
      description: 'Continuously pushing boundaries to develop cutting-edge technologies that solve complex manufacturing challenges',
      icon: 'ri-lightbulb-flash-line',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Quality',
      description: 'Maintaining uncompromising standards in every product and service we deliver to our customers',
      icon: 'ri-star-line',
      color: 'from-[#00D9C9] to-teal-500'
    },
    {
      title: 'Integrity',
      description: 'Building trust through honest communication, ethical practices, and transparent business relationships',
      icon: 'ri-shield-check-line',
      color: 'from-indigo-500 to-purple-500'
    },
    {
      title: 'Customer Focus',
      description: 'Putting customer success at the heart of everything we do, from design to after-sales support',
      icon: 'ri-customer-service-2-line',
      color: 'from-orange-500 to-red-500'
    },
    {
      title: 'Sustainability',
      description: 'Committed to environmental responsibility and developing eco-friendly manufacturing solutions',
      icon: 'ri-leaf-line',
      color: 'from-green-500 to-emerald-500'
    },
    {
      title: 'Collaboration',
      description: 'Fostering teamwork and partnerships to achieve shared goals and drive mutual success',
      icon: 'ri-team-line',
      color: 'from-pink-500 to-rose-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00D9C9]/10 rounded-full mb-6">
            <i className="ri-heart-line text-[#00D9C9] text-lg"></i>
            <span className="text-[#00D9C9] text-sm font-medium">Core Values</span>
          </div>
          <h2 className="text-4xl font-bold text-[#001E3C] mb-4">
            The Principles That Guide Us
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our values shape our culture and drive our commitment to excellence in everything we do
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden"
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${value.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#00D9C9]/10 to-[#00D9C9]/5 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-[#00D9C9] text-3xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#001E3C] mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>

              {/* Decorative Element */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#00D9C9]/5 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
